import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Page404 } from "./pages/page404";
import { Survey } from "./pages/survey";

const TestSurvey = () => {
  return <Survey inTestMode={true} />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/">
          <Route index element={<Page404 />} />
          <Route path=":id" element={<Survey />}>
            {/* testing purposes only */}
            {/* <Route path="test-survey" element={<Survey />}></Route> */}
          </Route>
        </Route>
        <Route path="/test/:id" element={<TestSurvey />} />
        <Route path="*" element={<Page404 />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
